<template>
  <div class="page">
    <div v-if="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Đang tải dữ liệu...</p>
    </div>
    <div class="receipt-tabs">
      <button
        v-for="item in tabs"
        :key="item.value"
        class="tab-btn"
        :class="{ active: tab === item.value }"
        @click="changeTab(item.value)"
      >
        {{ item.label }}

        <span v-if="item.value === 'trash' && trashCount > 0">
          ({{ trashCount }})
        </span>
        <span v-if="item.value === 'cancelled' && cancelledCount > 0">
          ({{ cancelledCount }})
        </span>
      </button>
    </div>
    <!-- <div class="tabs">
      <button :class="{ active: tab === 'general' }" @click="tab = 'general'">
        Danh sách
      </button>
      <button
        :class="{ active: tab === 'create_export_receipt' }"
        @click="tab = 'create_export_receipt'"
      >
        Tạo phiếu
      </button>
      <button :class="{ active: tab === 'trash' }" @click="tab = 'trash'">
        Thùng rác
      </button>
    </div> -->
    <div v-if="tab === 'all'" class="page_list">
      <!-- HEADER -->
      <div class="page-header">
        <h2>Danh sách phiếu xuất kho</h2>
        <button class="btn-create" @click="createExportReceipt">
          + Tạo phiếu
        </button>
      </div>

      <!-- FILTER -->
      <div class="receipt-filter">
        <input
          v-model="filters.keyword"
          placeholder="Tìm mã phiếu / khách hàng..."
        />

        <select v-model="filters.export_type">
          <option value="">Tất cả loại</option>
          <option value="ban_hang">Bán hàng</option>
          <option value="noi_bo">Nội bộ</option>
          <option value="huy">Hủy</option>
        </select>
        <input
          type="date"
          v-model="filters.from_date"
          placeholder="Từ ngày..."
        />
        <input
          type="date"
          v-model="filters.to_date"
          placeholder="Đến ngày..."
        />

        <button class="btn-search" @click="fetchData">Tìm kiếm</button>
      </div>

      <!-- TABLE -->
      <div class="card">
        <table class="table">
          <thead>
            <tr>
              <th>Mã phiếu</th>
              <th>Ngày</th>
              <th>Loại</th>
              <th>Người xuất phiếu</th>
              <th>Tổng tiền</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in receipts" :key="item.id">
              <td>{{ item.ma_phieu }}</td>
              <td>{{ item.ngay_xuat_phieu }}</td>
              <td>
                <span :class="'badge ' + item.loai_phieu">
                  {{ formatType(item.loai_phieu) }}
                </span>
              </td>
              <td>{{ item.nguoi_xuat }}</td>
              <td>{{ formatCurrency(item.tong_gia_tri) }}</td>
              <td>
                <button @click="viewDetail(item)" class="btn-icon" title="Xem">
                  👁
                </button>
                <button
                  @click="deleteItem(item.id)"
                  class="btn-icon"
                  title="Xoá"
                >
                  🗑
                </button>
                <button class="btn-cancel" @click="cancelItem(item.id)">
                  Huỷ
                </button>
              </td>
            </tr>

            <tr v-if="receipts.length === 0">
              <td colspan="6" class="empty">Không có dữ liệu</td>
            </tr>
          </tbody>
        </table>

        <!-- PAGINATION -->
        <div class="pagination">
          <button
            :disabled="pagination.current_page === 1"
            @click="changePage(pagination.current_page - 1)"
            class="btn btn-outline btn-sm"
          >
            Trước
          </button>

          <button
            v-for="page in visiblePages"
            :key="page"
            @click="changePage(page)"
            :class="[
              'btn',
              'btn-sm',
              page === pagination.current_page ? 'btn-primary' : 'btn-outline',
            ]"
          >
            {{ page }}
          </button>

          <button
            :disabled="pagination.current_page === pagination.last_page"
            @click="changePage(pagination.current_page + 1)"
            class="btn btn-outline btn-sm"
          >
            Sau
          </button>
        </div>
      </div>
    </div>
    <div v-if="tab === 'create_export_receipt'" class="page_create">
      <!-- HEADER -->
      <div class="page-header">
        <h3>Phiếu Xuất Kho</h3>
        <div class="actions">
          <button class="btn-cancel">Hủy</button>
          <button class="btn-save" @click="submitForm">Lưu phiếu</button>
        </div>
      </div>

      <!-- THÔNG TIN -->
      <div class="card">
        <h3>Thông tin phiếu</h3>

        <div class="form-grid">
          <div class="field">
            <label>Mã phiếu</label>
            <input v-model="form.code" disabled />
          </div>

          <div class="field">
            <label>Ngày xuất</label>
            <input type="date" v-model="form.export_date" />
          </div>

          <div class="field">
            <label>Loại xuất</label>
            <select v-model="form.export_type">
              <option value="">-- Chọn --</option>
              <option value="ban_hang">Bán hàng</option>
              <option value="noi_bo">Nội bộ</option>
              <option value="huy">Hủy</option>
              <option value="chuyen_kho">Chuyển kho</option>
            </select>
          </div>

          <div class="field">
            <label>Đối tượng</label>
            <input v-model="form.receiver" placeholder="Khách hàng / bộ phận" />
          </div>
        </div>
      </div>

      <!-- THÊM SẢN PHẨM -->
      <div class="card">
        <h3>Thêm sản phẩm</h3>

        <div class="add-product">
          <div class="field product-select">
            <select v-model="selectedProductId">
              <option value="">-- Chọn sản phẩm --</option>
              <option
                v-for="product in products"
                :key="product.id"
                :value="product.id"
              >
                {{ product.ten_hang }} (Tồn: {{ product.ton_kho }})
              </option>
            </select>
          </div>

          <div class="field qty">
            <input type="number" v-model="quantity" min="1" placeholder="SL" />
          </div>

          <button class="btn-add" @click="addProduct">+ Thêm</button>
        </div>
      </div>

      <!-- DANH SÁCH -->
      <div class="card">
        <h3>Danh sách sản phẩm</h3>

        <table class="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Tên</th>
              <th>Giá</th>
              <th>SL</th>
              <th>Thành tiền</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(item, index) in form.items" :key="index">
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ formatCurrency(item.price) }}</td>
              <td>
                <input type="number" v-model="item.quantity" min="1" />
              </td>
              <td>{{ formatCurrency(item.price * item.quantity) }}</td>
              <td>
                <button class="btn-delete" @click="removeItem(index)">
                  Xóa
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="total">
          Tổng tiền: <strong>{{ formatCurrency(totalAmount) }}</strong>
        </div>
      </div>
    </div>

    <div v-if="tab === 'cancelled'" class="page_trash">
      <!-- HEADER -->
      <div class="page-header">
        <h3>Thùng rác</h3>
        <div class="actions">
          <button class="btn-cancel">Hủy</button>
          <button>♻ Khôi phục</button>
        </div>
      </div>

      <div class="trash-alert">
        ⚠ Các phiếu xuất đã huỷ có thể khôi phục
      </div>

      <table class="receipt-table">
        <thead>
          <tr>
            <th>Mã phiếu</th>
            <th>Người tạo</th>
            <th>Tổng tiền</th>
            <th>Ngày xoá</th>
            <th width="180">Hành động</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in cancelledReceipts" :key="item.id">
            <td @click="viewDetail(item)">#{{ item.ma_phieu }}</td>

            <td>{{ item.nguoi_xuat }}</td>

            <td>{{ formatCurrency(item.tong_gia_tri) }}</td>

            <td>{{ formatDate(item.cancelled_at) }}</td>

            <td>
              <div class="action-group">
                <button class="restore-btn" @click="restoreStatus(item.id)">
                  Khôi phục
                </button>

                <button class="destroy-btn" @click="forceDelete(item.id)">
                  Xoá vĩnh viễn
                </button>
              </div>
            </td>
          </tr>

          <tr v-if="!trashReceipts.length">
            <td colspan="5">
              <div class="empty-trash">🗑 Thùng rác trống</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="tab === 'trash'" class="page_trash">
      <!-- HEADER -->
      <div class="page-header">
        <h3>Thùng rác</h3>
        <div class="actions">
          <button class="btn-cancel">Hủy</button>
          <button>♻ Khôi phục</button>
        </div>
      </div>

      <div class="trash-alert">
        ⚠ Các phiếu xuất trong thùng rác có thể khôi phục
      </div>

      <table class="receipt-table">
        <thead>
          <tr>
            <th>Mã phiếu</th>
            <th>Người tạo</th>
            <th>Tổng tiền</th>
            <th>Ngày xoá</th>
            <th width="180">Hành động</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in trashReceipts" :key="item.id">
            <td @click="viewDetail(item)">#{{ item.ma_phieu }}</td>

            <td>{{ item.nguoi_xuat }}</td>

            <td>{{ formatCurrency(item.tong_gia_tri) }}</td>

            <td>{{ formatDate(item.deleted_at) }}</td>

            <td>
              <div class="action-group">
                <button class="restore-btn" @click="restoreReceipt(item.id)">
                  Khôi phục
                </button>

                <button class="destroy-btn" @click="forceDelete(item.id)">
                  Xoá vĩnh viễn
                </button>
              </div>
            </td>
          </tr>

          <tr v-if="!trashReceipts.length">
            <td colspan="5">
              <div class="empty-trash">🗑 Thùng rác trống</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ExportReceiptModal
      v-if="showCreateExportReceiptModal"
      @close="showCreateExportReceiptModal = false"
      @save="saveExportReceipt"
    />

    <ExportReceiptDetailModal
      v-if="showExportReceiptDetailModal"
      :receipt="selectedExportReceipt"
      @close="showExportReceiptDetailModal = false"
      @update="fetchExportReceipt"
    />

    <ConfirmDialog
      v-if="showConfirmDialog"
      :title="confirmDialog.title"
      :message="confirmDialog.message"
      :type="confirmDialog.type"
      @confirm="confirmDialog.onConfirm"
      @cancel="showConfirmDialog = false"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, reactive } from "vue";
import { formatCurrency, formatDate } from "@/utils/helpers";
import { exportReceiptApi } from "@/services/api";
import { usePagination } from "@/composables/usePagination";
import { useToast } from "@/composables/useToast";
import ExportReceiptModal from "@/components/modal/exportReceipt/ExportReceiptModal.vue";
import ExportReceiptDetailModal from "@/components/modal/exportReceipt/ExportReceiptDetailModal.vue";
import ConfirmDialog from "@/components/modal/ConfirmDialog.vue";

const form = ref({
  code: "PX-" + Date.now(),
  export_date: new Date().toISOString().substr(0, 10),
  export_type: "",
  receiver: "",
  items: [],
});
const filters = ref({
  keyword: "",
  export_type: "",
  from_date: "",
  to_date: "",
});
const confirmDialog = reactive({
  title: "",
  message: "",
  type: "danger",
  onConfirm: () => {},
});
const tabs = [
  { label: "Tạo phiếu", value: "create_export_receipt" },
  { label: "Tất cả", value: "all" },
  { label: "Đã xuất", value: "completed" },
  { label: "Đã huỷ", value: "cancelled" },
  { label: "Thùng rác", value: "trash" },
];
const loading = ref(false);
const showCreateExportReceiptModal = ref(false);
const showExportReceiptDetailModal = ref(false);
const showConfirmDialog = ref(false);
const selectedExportReceipt = ref(null);
const toast = useToast();
const tab = ref("all");
const receipts = ref([]);
const products = ref([]);
const selectedProductId = ref("");
const quantity = ref(1);
const trashReceipts = ref([]);
const trashCount = computed(() => trashReceipts.value.length);
const cancelledReceipts = ref([]);
const cancelledCount = computed(() => cancelledReceipts.value.length);

// fetch data
const fetchExportReceipt = async () => {
  loading.value = true;
  try {
    const response = await exportReceiptApi.getExportReceipts({
      search: filters.value.keyword,
      page: pagination.current_page,
      per_page: pagination.per_page || 15,
    });
    receipts.value = response.data.data.data || response.data;
    const { ...paginationMeta } = response.data.data;
    updatePagination(paginationMeta);
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "Lỗi tải dữ liệu phiếu xuất kho";
    toast.error(errorMessage);
    console.log(error);
  } finally {
    loading.value = false;
  }
};

const fetchTrashReceipts = async () => {
  try {
    const response = await exportReceiptApi.getTrashedExportReceipts();
    trashReceipts.value = response.data.data.data || response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "Lỗi tải dữ liệu thùng rác";
    toast.error(errorMessage);
    console.log(error);
  }
};

const fetchCancelledReceipts = async () => {
  try {
    const response = await exportReceiptApi.getCancelledExportReceipts();
    cancelledReceipts.value = response.data.data || response.data;
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "Lỗi tải dữ liệu phiếu đã huỷ";
    toast.error(errorMessage);
    console.log(error);
  }
};

// add product
const addProduct = () => {
  if (!selectedProductId.value) return;

  const product = products.value.find((p) => p.id === selectedProductId.value);

  if (!product) return;

  const exist = form.value.items.find((i) => i.product_id === product.id);

  if (exist) {
    exist.quantity += quantity.value;
  } else {
    form.value.items.push({
      product_id: product.id,
      name: product.ten_hang,
      price: product.gia_ban,
      quantity: quantity.value,
    });
  }

  selectedProductId.value = "";
  quantity.value = 1;
};

const changeTab = (value) => {
  tab.value = value;
  if (value === "trash") {
    fetchTrashReceipts();
  }
  if (value === "cancelled") {
    fetchCancelledReceipts();
  } else if (value === "all") {
    fetchExportReceipt();
  }
};

// remove
const removeItem = (index) => {
  form.value.items.splice(index, 1);
};

// total
const totalAmount = computed(() => {
  return form.value.items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0,
  );
});

//Format
const formatType = (type) => {
  switch (type) {
    case "ban_hang":
      return "Bán hàng";
    case "noi_bo":
      return "Nội bộ";
    case "huy":
      return "Hủy";
    default:
      return type;
  }
};

//show Modal
const createExportReceipt = () => {
  showCreateExportReceiptModal.value = true;
};

const viewDetail = (item) => {
  // console.log("View detail for", item);
  selectedExportReceipt.value = item;
  showExportReceiptDetailModal.value = true;
};

const saveExportReceipt = () => {
  fetchExportReceipt();
  showCreateExportReceiptModal.value = false;
};

const deleteItem = (id) => {
  confirmDialog.title = "Xoá phiếu xuất kho";
  confirmDialog.message = "Hành động này có thể khôi phục trong thùng rác";
  confirmDialog.type = "danger";
  showConfirmDialog.value = true;
  confirmDialog.onConfirm = async () => {
    loading.value = true;
    try {
      const response = await exportReceiptApi.softDeleteExportReceipt(id);
      if (response.data.success) {
        toast.success(response.data.message);
        receipts.value = receipts.value.filter((r) => r.id !== id);
        if (typeof fetchTrashReceipts === "function") {
          await fetchTrashReceipts();
        }
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Lỗi xoá phiếu xuất kho";
      toast.error(errorMsg);
    } finally {
      loading.value = false;
      showConfirmDialog.value = false;
    }
  };
};

const cancelItem = async (id) => {
  confirmDialog.title = "Xoá phiếu xuất kho";
  confirmDialog.message = "Hành động này có thể khôi phục trong thùng rác";
  confirmDialog.type = "danger";
  showConfirmDialog.value = true;
  confirmDialog.onConfirm = async () => {
    try {
      const response = await exportReceiptApi.cancelExportReceipt(id);
      if (response.data.success) {
        toast.success(response.data.message);
        fetchExportReceipt();
        fetchCancelledReceipts();
      }
    } catch (error) {
      const errorMsg =
        error.response?.data?.message || "Lỗi huỷ phiếu xuất kho";
      toast.error(errorMsg);
    } finally {
      loading.value = false;
      showConfirmDialog.value = false;
    }
  };
};

const restoreReceipt = async (id) => {
  try {
    const response = await exportReceiptApi.restoreExportReceipt(id);
    if (response.data.success) {
      toast.success(response.data.message);
      trashReceipts.value = trashReceipts.value.filter((r) => r.id !== id);
      fetchExportReceipt();
    }
  } catch (error) {
    const errorMsg =
      error.response?.data?.message || "Lỗi khôi phục phiếu xuất kho";
    toast.error(errorMsg);
  }
};

const restoreStatus = async (id) => {
  try {
    const response = await exportReceiptApi.restoreStatus(id);
    if (response.data.success) {
      toast.success(response.data.message);
      cancelledReceipts.value = cancelledReceipts.value.filter(
        (r) => r.id !== id,
      );
      fetchExportReceipt();
    }
  } catch (error) {
    const errorMsg =
      error.response?.data?.message || "Lỗi khôi phục phiếu xuất kho";
    toast.error(errorMsg);
  }
};

// submit
const submitForm = async () => {
  // await axios.post("/api/export-receipts", {
  //   ...form.value,
  //   total_amount: totalAmount.value,
  // });

  alert("Lưu thành công!");
};

const { pagination, visiblePages, changePage, updatePagination } =
  usePagination(fetchExportReceipt);

onMounted(() => {
  fetchExportReceipt();
  fetchTrashReceipts();
  fetchCancelledReceipts();
});
</script>

<style scoped>
.page {
  padding: 20px;
  background: #f3f4f6;
}

.page-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page_list,
.page_create,
.page_trash {
  padding: 20px 0;
}
.tabs {
  display: flex;
  border-bottom: 1px solid #ddd;
}

.tabs button {
  padding: 10px 20px;
  cursor: pointer;
}

.tabs button.active {
  border-bottom: 2px solid #42b983;
}
.card {
  background: #fff;
  padding: 16px;
  border-radius: 10px;
  margin-bottom: 20px;
}

/* ===== FILTER ===== */
.receipt-filter {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.receipt-filter input,
.receipt-filter select {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  outline: none;
}

.btn-search {
  background: #333;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
}

/* grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

/* field */
.field {
  display: flex;
  flex-direction: column;
}

.field input,
.field select {
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 10px;
}

/* add product */
.add-product {
  display: flex;
  gap: 10px;
}

.product-select select {
  width: 250px;
}

.qty input {
  width: 80px;
  text-align: center;
}

/* buttons */
.btn-add {
  background: #42b983;
  color: #fff;
  border: none;
  padding: 0 16px;
  border-radius: 6px;
}

.btn-save {
  background: #42b983;
  color: #fff;
  padding: 8px 16px;
  border: none;
}

.btn-cancel {
  background: #e5e7eb;
  padding: 8px 16px;
  border: none;
}

.btn-delete {
  background: red;
  color: #fff;
  border: none;
  padding: 4px 8px;
}

/* .actions button {
  margin-right: 6px;
  border: none;
  background: none;
  cursor: pointer;
} */

/* table */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.table th,
.table td {
  border: 1px solid #eee;
  padding: 8px;
}

.total {
  text-align: right;
  margin-top: 10px;
}

.badge.ban_hang {
  background: #42b983;
}

.badge.noi_bo {
  background: #3b82f6;
}

.trash-wrapper {
  background: white;

  border-radius: 16px;

  padding: 20px;
}

.trash-alert {
  background: #fff7ed;

  color: #c2410c;

  padding: 14px 16px;

  border-radius: 10px;

  margin-bottom: 20px;

  font-weight: 500;
}

.receipt-table {
  width: 100%;
  border-collapse: collapse;
}

.receipt-table th,
.receipt-table td {
  padding: 14px;

  border-bottom: 1px solid #e5e7eb;

  text-align: left;
}

.action-group {
  display: flex;
  gap: 10px;
}

.restore-btn {
  border: none;

  background: #16a34a;
  color: white;

  padding: 8px 14px;

  border-radius: 8px;

  cursor: pointer;
}

.destroy-btn {
  border: none;

  background: #dc2626;
  color: white;

  padding: 8px 14px;

  border-radius: 8px;

  cursor: pointer;
}

.empty-trash {
  padding: 40px;
  text-align: center;

  color: #94a3b8;
}

.receipt-tabs {
  display: flex;
  gap: 12px;

  margin-bottom: 20px;
}

.tab-btn {
  border: none;

  background: white;

  padding: 10px 18px;

  border-radius: 10px;

  cursor: pointer;

  font-weight: 600;

  position: relative;

  transition: 0.2s;
}

.tab-btn.active {
  background: #2563eb;
  color: white;
}
</style>
